import { styled } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { Tokens, name } from './const';

export const TariffBenefit = styled(Box, { name, slot: 'Benefit' })(({ theme }) => ({
  ...theme.typography['small text bold'],
  textAlign: 'center',
  textTransform: 'uppercase',
  backgroundColor: Tokens.BenefitBG(),
  color: Tokens.BenefitFG(),
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
}));
